import { JSX } from 'react';

import MotionButton from '@motion/Button';
import { Table } from '@tanstack/react-table';

export interface Props<T> {
  table: Table<T>;
}

export const DataTableFooter = <T,>({ table }: Props<T>): JSX.Element => {
  return (
    <div className="flex items-center justify-end space-x-2 py-4">
      <div className="flex-1 text-sm text-muted-foreground">
        {table.getFilteredSelectedRowModel().rows.length} of{' '}
        {table.getFilteredRowModel().rows.length} row(s) selected.
      </div>
      <div className="space-x-2">
        <MotionButton
          variant="outline"
          // size="sm"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}>
          Previous
        </MotionButton>
        <MotionButton
          variant="outline"
          // size="sm"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}>
          Next
        </MotionButton>
      </div>
    </div>
  );
};

export default DataTableFooter;
